// Front/src/config.js

const isLocalDev =
  typeof window !== "undefined" && window.location.hostname === "localhost";

const config = {
   
    // Application port
    PORT: process.env.REACT_APP_PORT || 4000,
  
    // API URL
    API_URL: isLocalDev ? "" : process.env.REACT_APP_DOCNET_WEB_API_URL,
  
    // Priority username:
    // Application version
    CURRENT_VERSION: process.env.REACT_APP_CURRENT_VERSION,
  
    // Frontend client URLs
    FRONT_END_CLIENT_URL: process.env.REACT_APP_FRONT_END_CLIENT_URL || "http://localhost:3000",
};

// Use ES module export
export default config;
  
